import { useSelector } from 'react-redux'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { EMPTY_VALUE } from '../../../../utils/common'

export const DateTimeCell = ({ data }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()

  return (
    <Element className="whiteSpaceNowrap">
      {data && data !== EMPTY_VALUE
        ? formatDateTime(data, FORMAT.DATE_TIME, locale, timezone)
        : EMPTY_VALUE}
    </Element>
  )
}
